import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ToasterConfig, ToastType } from 'src/app/_shared/toaster/toaster-config.model';

/**
 * angular2-toaster's ToasterService API on top of ngx-toastr.
 */
@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private toastrService = inject(ToastrService);

  config = new ToasterConfig();

  pop(type: ToastType, title?: string, body?: string): void {
    const timeout = typeof this.config.timeout === 'number' ? this.config.timeout : this.config.timeout[type];
    this.toastrService.show(
      body,
      title,
      {
        positionClass: this.config.positionClass,
        // angular2-toaster keeps a toast without a timeout open until it is clicked.
        disableTimeOut: !timeout,
        timeOut: timeout,
        // Hovering stops the timer, leaving restarts it in full (mouseoverTimerStop).
        extendedTimeOut: this.config.mouseoverTimerStop ? timeout : 0
      },
      type
    );
  }

  clear(): void {
    this.toastrService.clear();
  }
}
